
import {Component, Prop,  Vue} from 'vue-property-decorator';
import user_module from '@/modules/user/index';


@Component
export default class TrialButton extends Vue {

  @Prop({ default: '' }) extraClass;

  get token(){

    return user_module.token;
  }

  get product(){

    return user_module.userProducts.find(product => product.id === this.$route.meta.product)

  }

  get bought(){

    return this.product?.bought;
  }



  getTrial(){

    const {productCode} = this.product;

    let source = this.$route.query.source || '';
    
    if (typeof source === 'string'){

      source = '&source=' + source;
      
    } 
    
    if (this.token){

     user_module.getTrial(productCode);
     this.$router.push('/trial?product=' + productCode + source);  

   } else {

    this.$router.push('/trial_logout?product=' + productCode + source);  

   }

 }


}